import React from "react";

// Placeholder numbers — swap with real metrics.
const STATS = [
  { value: "100+", label: "Trusted Brands" },
  { value: "50K+", label: "Rooms Visualized" },
  { value: "98%", label: "Customer Satisfaction" },
];

export default function Stats() {
  return (
    <section className="bg-white py-12 sm:py-16">
      <div className="mx-auto grid max-w-5xl grid-cols-3 gap-3 px-4 sm:gap-10 md:px-8">
        {STATS.map((stat) => (
          <div key={stat.label} className="text-center">
            <p className="text-2xl font-bold text-neutral-900 sm:text-4xl md:text-5xl">{stat.value}</p>
            <p className="mt-1 text-xs text-neutral-500 sm:mt-2 sm:text-base">{stat.label}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
